module.exports = "/images/start-sell-online.svg?790aca9a30dbca2ccf03386e63d2b673";